import { v4 as uuidv4 } from 'uuid';

const STORAGE_KEY = 'anonymousId';

export const getAnalyticsUserId = (): string => {
	// Return early if not in browser
	if (typeof window === 'undefined') {
		return uuidv4();
	}

	// Try to get existing ID from localStorage
	const storedId = window.localStorage?.getItem(STORAGE_KEY);
	if (storedId) {
		return storedId;
	}

	// Try to get Marketing Cloud Visitor ID
	const marketingCloudId = (window as any).s?.visitor?.getMarketingCloudVisitorID?.();
	if (marketingCloudId) {
		window.localStorage?.setItem(STORAGE_KEY, marketingCloudId);
		return marketingCloudId;
	}

	// Generate new UUID and store it.
	// Use uuidv4() (backed by crypto.getRandomValues) rather than crypto.randomUUID(),
	// which is only available in secure contexts (HTTPS / localhost) and throws over plain http.
	const newId = uuidv4();
	window.localStorage?.setItem(STORAGE_KEY, newId);
	return newId;
};

export default getAnalyticsUserId;
